import OrganizationsPanel from '@/components/Organizations/OrganizationsPanel';

export default function Organizations() {
  return (
    <div className="mt-8">
      <OrganizationsPanel />
    </div>
  );
}
